module.exports = __WEBPACK_EXTERNAL_MODULE_41__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"es6-promise","commonjs":"es6-promise","commonjs2":"es6-promise","root":"Promise"}
 ** module id = 41
 ** module chunks = 0 1
 **/